import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { traspasomodelo } from '@sharedV11/classes/tarifas/traspasomodelo';
import { Mensaje } from '@sharedV11/models';
import { GrupoTipoAbonadoItem } from '@sharedV11/models/grupo-tipo-abonado';
import { HttpErrorsService } from '@sharedV11/services/alerts/errors/http-errors.service';
import { SnackbarInfoService } from '@sharedV11/services/alerts/snackbar-info/snackbar-info.service';
import { ConectarApiService } from '@sharedV11/services/api/connection/conectar-api.service';
import { MicroserviceService } from '@sharedV11/services/microservices/microservice.service';
import { PanelService } from '@sharedV11/services/panel/panel.service';
import { Translator } from '@sharedV11/services/translator/translator.service';
import { DualListComponent } from 'angular-dual-listbox';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatosLista } from 'src/app/components/mestres/categorias-jerarquias';

@Component({
  selector: 'app-edit-grupo-tipo-abonado',
  templateUrl: './edit-grupo-tipo-abonado.component.html',
  styleUrls: ['./edit-grupo-tipo-abonado.component.scss']
})
export class EditGrupoTipoAbonadoComponent implements OnInit {

    
    private static readonly CARACTERES_PROHIBIDOS = ['--', ';', '/*', '*/', '@@'];

    static caracteresProhibidosValidator(control: AbstractControl): ValidationErrors | null {
      const v = (control.value ?? '').toString();
      if (!v) return null;
      const encontrado = EditGrupoTipoAbonadoComponent.CARACTERES_PROHIBIDOS.find((seq) => v.includes(seq));
      return encontrado ? { caracteresProhibidos: { secuencia: encontrado } } : null;
    }

    static sanitizarCaracteresProhibidos(valor: string): string {
      let s = (valor ?? '').toString();
      EditGrupoTipoAbonadoComponent.CARACTERES_PROHIBIDOS.forEach((seq) => {
        s = s.split(seq).join('');
      });
      return s;
    }

    loading = true;
    private ngUnsubscribe = new Subject();
  
    @Input() pkId: string;
    @Input() mode: string;
    @Input() modificar: boolean;
    @Input() otherProps: { [key: string]: string };
    @ViewChildren('expansionPanel') expansionPanelList!: QueryList<MatExpansionPanel>;
  
    translation: any;
  
    editRegistroForm: FormGroup;
  
    //centros
    centrosSinAsignar: DatosLista[] = [];
    centrosAsignados: DatosLista[] = [];
  
    format = {
      add: "Añadir",
      remove: "Borrar",
      all: "Todos",
      none: "Ninguno",
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  
    model = new traspasomodelo();

    formValues: { [key: string]: string };
  
    constructor(
      private fb: FormBuilder,
      private translator: Translator,
      private panelService: PanelService,
      private snackvar_service: SnackbarInfoService,
      private httpErrorService: HttpErrorsService,
      private conectarApiService: ConectarApiService,
      private microService: MicroserviceService
    ) {}
  
    ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  
    ngOnInit(): void {
      this.initializeTranslate();
      this.initializeFormWithoutData();
      this.getCentros().then(() => {
        this.manageForm(this.pkId, this.mode);
        this.valuedChanged();
      });
    }
  
    initializeFormWithoutData() {
      this.editRegistroForm = this.fb.group({
        pkId: [""],
        Nombre: [
          '',
          [
            Validators.required,
            Validators.maxLength(20),
            EditGrupoTipoAbonadoComponent.caracteresProhibidosValidator,
          ],
        ],
        Descripcion: [
          '',
          [Validators.maxLength(50), EditGrupoTipoAbonadoComponent.caracteresProhibidosValidator],
        ],
        CentrosIds: [""],
        CentrosNombres: [""],
      });
    }

  
    manageForm(pkId, mode) {
      if (mode == "I") {
        this.formValues = this.editRegistroForm.value;
        this.loading = false;
      }
  
      if (pkId) {
        if (this.otherProps) {
          const modifiedElement: { [key: string]: string } = {
            ...this.otherProps
          }
  
          this.updateFormValues(modifiedElement);
          this.loading = false;
        }
      }
    }
  
    async getCentros(): Promise<void> {
      try {
        const response = await this.conectarApiService.getDatosListasMS({ nombreTabla: 'centros', }).toPromise();
  
          if (response?.datosResult && response.datosResult?.datosListas?.length) {
            this.centrosSinAsignar = response?.datosResult?.datosListas;
          } else {
            this.centrosSinAsignar = [];
            this.centrosAsignados = [];
          }
  
          if (response?.mensajes?.length) {
            this.showErrorMessageOnSnackBar(response.mensajes, 'GetListados');
          }
  
      } catch (error) {
        console.info(`While loading centros de avisos en la web happend error ${error}`);
        this.centrosSinAsignar = [];
        this.centrosAsignados = [];
      }
    }
  
    updateFormValues(formValues: { [key: string]: any }) {
      if (formValues) {
        const updatedFormValues = Object.keys(formValues).reduce((result, currKey) => {
          if (currKey === 'CentrosIds') {
            result[currKey] = formValues[currKey];

            if (formValues[currKey]) {
              this.centrosAsignados = this.centrosSinAsignar.filter((centro) => formValues[currKey]?.split(',').includes(`${centro.pkid}`));
            } else {
              this.centrosAsignados = [];
            }

          } else {
            result[currKey] = formValues[currKey]
          }


          return result;
        }, {})
  
        this.editRegistroForm.patchValue(updatedFormValues);
        this.formValues = updatedFormValues;
      }
    }

    getCentrosAsignados(): string {
      const  result = this.centrosAsignados?.length ? this.centrosAsignados?.map((centro) => centro?.pkid).join(',') : '';

      return result;
    }

    isMovedCentro(): void {
      this.panelService.setDiscardChanges(false);
    }
  
    valuedChanged() {
      this.editRegistroForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {

        if (this.formValues) {
          this.panelService.setDiscardChanges(false);
  
          if (JSON.stringify(value) === JSON.stringify(this.formValues)) {
            this.panelService.setDiscardChanges(true);
          }
        }
      });
    }
  
    submit() {
      this.editRegistroForm.markAllAsTouched();
  
      const formValues: { [key: string]: string } = this.editRegistroForm.value;
      const preparedPayload: Partial<GrupoTipoAbonadoItem> = this.getPreparedPayload(formValues);
  
      if (this.editRegistroForm.valid) {
        this.manageApi(preparedPayload, this.mode);
      }
    }
  
    destroy() {
      this.panelService.setDiscardChanges(true);
      this.panelService.setClosePanel(null);
    }
  
    save() {
      this.loading = false;
      this.panelService.setDiscardChanges(true);
  
      this.panelService.setSavePanel(null);
    }
  
    discard() {
      this.updateFormValues(this.formValues);
      this.editRegistroForm.markAllAsTouched();
    }
  
    manageApi(formValues: Partial<GrupoTipoAbonadoItem>, mode) {
      this.loading = true;
  
      switch (mode) {
        case "U":
          //update
          this.InsFormValues(formValues);
          break;
          
        default:
            formValues.pkId = '0';
            this.InsFormValues(formValues);
          break;
      }
    }
    
    InsFormValues(formValues: Partial<GrupoTipoAbonadoItem>) {
      this.conectarApiService.insUpdGrupoTipoAbonado(formValues)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (response) => {
            this.nextWindow(response);
          },
          (error) => {
            this.httpErrorService.identificarErrores(error);
          }
        );
    }
  
    nextWindow(response: any) {
      const err = this.existErrors();
      if (!this.existErrors()) {
        this.save();
        this.destroy();
        this.showErrorMessageOnSnackBar(response.Mensajes, 'InsUpdCalendariosCuadrosMesError');
      }
    }
  
    showErrorMessageOnSnackBar(mensajes: Mensaje[], serviceName?: string): void {
      if (mensajes.length > 0) {
        mensajes.forEach((element) => {
          const description = serviceName ? this.translator[`${serviceName}${element.CodigoMensaje}`] : element.DescripcionMensaje;
  
          this.snackvar_service.openSnackBar(
            description ?? element.DescripcionMensaje,
            "",
            "red-snackbar",
            serviceName ? "" : element.CodigoMensaje
          );
        });
      } else {
        this.snackvar_service.openSnackBar(
          this.translation["MensajeSuccessSnackBar"],
          "",
          "green-snackbar"
        );
      }
    }
  
    getPreparedPayload(formValues: { [key: string]: string }):  Partial<GrupoTipoAbonadoItem> {  
  
      const body: Omit<GrupoTipoAbonadoItem, 'CentrosNombres' | 'Fondos' | 'ConMotivo'> = {
        pkId: formValues['pkId'] ?? "",
        Nombre: formValues['Nombre'] || "",
        Descripcion: formValues['Descripcion'] || "",
        CentrosIds: this.getCentrosAsignados()
      };
  
      return body;
    }
    
    async initializeTranslate() {
      this.translation = this.translator.GetTranslations();
      this.format = {
        add: this.translation.Anadir,
        remove: this.translation.Borrar,
        all: this.translation.Todos,
        none: this.translation.Ninguno,
        direction: DualListComponent.LTR,
        draggable: true,
        locale: "es",
      };
    }  
  
    existErrors() {
      return this.editRegistroForm.get("pkId").errors
    }
  
    getErrorMessage(field: string) {
      const control = this.editRegistroForm.get(field);
      let errorMessage = 'Error'
  
      if (control && control.errors) {
        if (control.errors.required) {
          return this.translation["CampoRequerido"];
        }
  
        switch (field) {
          case "Nombre":
          case "Descripcion":
            if (control.hasError('maxlength')) {
              const requiredLength = control.errors['maxlength']?.requiredLength ?? 0;
              errorMessage =
                (this.translation['MaximoCaracteres'] ||
                  this.translation['Maximo'] ||
                  'Máximo') +
                ' ' +
                requiredLength +
                ' ' +
                (this.translation['CaracteresPermitidos'] || 'caracteres permitidos');
            } else if (control.hasError('caracteresProhibidos')) {
              const seq = control.errors['caracteresProhibidos']?.secuencia ?? '';
              const msg =
                this.translation['CaracteresNoPermitidos'] ||
                'No se permiten los caracteres: -- ; /* */ @@. Carácter bloqueado: ';
              errorMessage = msg + `"${seq}"`;
            }
            break;

          default:
            break;
        }
      }
  
      return errorMessage;
    }
  
    validateFields(field: string) {
      return this.isValidAnyField(field);
    }
  
    isValidAnyField(field: string) {
      let fc_pv = this.editRegistroForm.controls;
      return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
    }

    onNombreInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      const valor = input.value ?? '';
      const sanitizado = EditGrupoTipoAbonadoComponent.sanitizarCaracteresProhibidos(valor);
      if (sanitizado !== valor) {
        const ctrl = this.editRegistroForm.get('Nombre');
        if (ctrl) {
          ctrl.setValue(sanitizado, { emitEvent: true });
          input.value = sanitizado;
        }
      }
    }

    onDescripcionInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      const valor = input.value ?? '';
      const sanitizado = EditGrupoTipoAbonadoComponent.sanitizarCaracteresProhibidos(valor);
      if (sanitizado !== valor) {
        const ctrl = this.editRegistroForm.get('Descripcion');
        if (ctrl) {
          ctrl.setValue(sanitizado, { emitEvent: true });
          input.value = sanitizado;
        }
      }
    }
}
